import { createSelector } from "reselect";

import { ExecutionBriefsState } from "../../../../redux/reducers/executionBriefsReducer";
import { ExecutionBriefWorkOrdersState } from "../../types/execution-brief-work-orders/execution-brief-work-orders.interface";

import { getExecutionBriefState } from "../execution-brief.store";
import Store from "../../../../redux/store";
import * as actions from "./execution-brief-work-orders.actions";

export const getExecutionBriefWorkOrdersState = createSelector(
  getExecutionBriefState,
  (brief: ExecutionBriefsState) => brief.workOrders
);

export const getWorkOrders = createSelector(
  getExecutionBriefWorkOrdersState,
  (state: ExecutionBriefWorkOrdersState) => state.results || []
);

export const getErrors = createSelector(
  getExecutionBriefWorkOrdersState,
  (state: ExecutionBriefWorkOrdersState) => state.errors
);

export const isLoading = createSelector(
  getExecutionBriefWorkOrdersState,
  (state: ExecutionBriefWorkOrdersState) => state.loading
);

export function fetchWorkOrders() {
  Store.dispatch(actions.fetchWorkOrders());
}
